import {timer as observableTimer,  Observable, Subscription } from 'rxjs';
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MonitorService } from '../../services/monitor.service';
import { MonitorLayout } from '../../models/monitor-status';
import { DateTimeService } from '../../../shared/datetime/datetime.service';
import { LoadingPanelService, LoadingPanelSettings } from '../../../shared/loading-panel/loading-panel.service';
import { SvgIconComponent } from '../../../shared/icons/svg-icon.component';

import { MonitorDisplayComponent } from '../monitor-display/monitor-display.component';

@Component({
    selector: 'app-monitor-status',
    templateUrl: './monitor-status.component.html',
    styleUrls: ['./monitor-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, MonitorDisplayComponent]
})
export class MonitorStatusComponent implements OnInit {
    monitorLayout: MonitorLayout;

    @ViewChild('fullscreen', { static: true }) fullscreenWrapperElement;

    constructor(
        public dateTimeService: DateTimeService,
        private loadingPanelService: LoadingPanelService,
        private monitorService: MonitorService) { }

    public timerInterval = 10000;
    public timer: Observable<number>;
    public timerSub: Subscription;
    public lastUpdate = new Date();
    public isUpdating = false;
    public isFullScreen = false;
    public isDragging: boolean = false;

    async ngOnInit(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanel(new LoadingPanelSettings('Loading monitor status...'));
            this.monitorLayout = await this.monitorService.getMonitorLayout();
            this.subscribe();
        } finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    ngOnDestroy() {
        this.timerSub.unsubscribe();
    }

    refreshData() {
        this.isUpdating = true;
        this.monitorService.getMonitorLayout().then(monitorLayout => {
            this.monitorLayout = monitorLayout;
            this.lastUpdate = new Date();
            this.isUpdating = false;
        }).catch(() => { });
    }

    private subscribe() {
        this.timer = observableTimer(this.timerInterval, this.timerInterval);
        this.timerSub = this.timer.subscribe(t => {
            if (!this.isDragging) {
                this.refreshData()
            }
        });
    }

    goFullScreen() {
        if (this.fullscreenWrapperElement.nativeElement.requestFullscreen) {
            this.isFullScreen = true;
            this.fullscreenWrapperElement.nativeElement.requestFullscreen();
        }
        else if (this.fullscreenWrapperElement.nativeElement.webkitRequestFullscreen) {
            this.isFullScreen = true;
            this.fullscreenWrapperElement.nativeElement.webkitRequestFullscreen();
        }
        else if (this.fullscreenWrapperElement.nativeElement.mozRequestFullScreen) {
            this.isFullScreen = true;
            this.fullscreenWrapperElement.nativeElement.mozRequestFullScreen();
        }
    }

    onTriggerRefresh(e: boolean): void {
        if (e === true) {
            this.refreshData();
        }
    }

}
